import { render, staticRenderFns } from "./SubscribeBridge.vue?vue&type=template&id=c56c20a8&scoped=true"
import script from "./SubscribeBridge.vue?vue&type=script&lang=js"
export * from "./SubscribeBridge.vue?vue&type=script&lang=js"
import style0 from "./SubscribeBridge.vue?vue&type=style&index=0&id=c56c20a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c56c20a8",
  null
  
)

export default component.exports